import { render } from "./OurOffer.vue?vue&type=template&id=113c4a6d&scoped=true"
import script from "./OurOffer.vue?vue&type=script&lang=js"
export * from "./OurOffer.vue?vue&type=script&lang=js"

import "./OurOffer.vue?vue&type=style&index=0&id=113c4a6d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113c4a6d"]])

export default __exports__